import { required } from "react-admin";

// Could be partial e-mail (catch-all)
export const validateFromEmailAddress = [required()];

// Could be list of e-mail addresses (comma, semicolon or whitespace separated)
export const validateToEmailAddress = [required()];
